import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Observable } from "rxjs";
import { BusyService } from "./busy.service";

@Component({
  selector: 'skitbs-ios-tooltip',
  template:
    `
            <div class="Wid100 TexAlCenter PosFixed" style="bottom: 0px;right: 0px;" *ngIf="showIOSHomeTooltip">
                <div class="DispInlBlock BordRad10 Wid90" style="padding: 0 12px 12px 12px; z-index: 99; background-color: #d9e0e1">
                    <div class="d-flex">
                        <div class="d-col TexAlLeft" style="margin-left: 10px;">
                            Install this webapp on your iPhone: tap <img src="assets/icons/ios_icon_link.svg" width="22" height="22" style="margin-top: 6px;"/> and then Add to homescreen.
                        </div>
                        <div><i class="pi pi-times Gray" (click)="showIOSHomeTooltip = false"></i></div>
                    </div>
                </div>
                <br/>
                <div class="TexAlCenter" style="margin: auto; width: 0;  height: 0;  border-left: 20px solid transparent;  border-right: 20px solid transparent;  border-top: 20px solid #d9e0e1;">
                </div>
            </div>
        `
})
export class IosTooltipComponent implements AfterViewInit {

  showIOSHomeTooltip: boolean = false;

  /**
   * Lifecycle.
   */
  ngAfterViewInit() {
    this.detectIOS_Home_Screen();
  }


  private detectIOS_Home_Screen(): boolean {

    const userAgent = window.navigator.userAgent.toLowerCase();
    if (!/iphone|ipad|ipod/.test(userAgent)) {
      return false;
    }

    if(('standalone' in window.navigator) && (window.navigator['standalone'])){
      this.showIOSHomeTooltip = false;
      return false;
    }

    /* if (!('standalone' in window.navigator) && !(window.navigator['standalone'])) {
      return false;
    }*/
    this.showIOSHomeTooltip = true;
    return true;
  }
}